import { useState, useEffect, Fragment } from "react";
import {
  CardNumberElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Toaster } from "react-hot-toast";
import Loader from "../Loader/loader";
import TrackingScripts from "./trackingComponent";
import { handleSubmit } from "./eventHandler";
import PersonalDetailsSection from "../checkout/PersonalDetailsSection";
import PaymentDetailsSection from "../checkout/PaymentDetailsSection";
import DisclaimerSection from "../checkout/DisclaimerSection";
import { useCheckoutForm } from "../checkout/useCheckoutForm";
import { useNavigate, useLocation } from "react-router-dom";
import SDK from "../../config";
import axios from "axios";

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const {
    email,
    cardName,
    showCardDetails,
    pageLoader,
    paymentRequest,
    canMakePayment,
    regionText,
    selectedPlan,
    setCardName,
    setShowCardDetails,
    setPageLoader,
    handleEmailChange,
    getCurrencySymbol,
  } = useCheckoutForm(stripe);

  const onSubmit = async (event) => {
    handleSubmit(
      event,
      stripe,
      elements,
      email,
      CardNumberElement,
      cardName,
      setPageLoader,
      navigate
    );
  };

  return (
    <Fragment>
      <TrackingScripts />
      <Loader pageLoader={pageLoader} style={{ width: "100vw" }} />
      <Toaster />

      <div>
        <div>
          <form onSubmit={onSubmit}>
            <div className="bg-primary200 rounded-sm p-6 my-8">
              <PersonalDetailsSection
                email={email}
                onEmailChange={handleEmailChange}
              />

              <PaymentDetailsSection
                selectedPlan={selectedPlan}
                canMakePayment={canMakePayment}
                paymentRequest={paymentRequest}
                showCardDetails={showCardDetails}
                onShowCardDetails={() => setShowCardDetails(true)}
                cardName={cardName}
                onCardNameChange={(e) => setCardName(e.target.value)}
                getCurrencySymbol={getCurrencySymbol}
                stripeEnabled={!!stripe}
              />
            </div>
          </form>
        </div>

        <DisclaimerSection regionText={regionText} />
      </div>
    </Fragment>
  );
};

export default CheckoutForm;
